import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_TIME_FORMAT } from "src/common/constants";
import { KYBAvailableServices } from "src/modules/3rd-party-management/constants/Common";
import {
    getKybReportDisplayTitle,
    resolveKybReportSource,
} from "src/modules/3rd-party-management/helpers/kybReports";

import styles from "../../styles";
import { formatDisplayValue, formatPersonName } from "../../helpers";

const dateUtils = new DateUtils();

const readPerson = (value) => {
    if (!value) {
        return "";
    }

    if (typeof value === "string") {
        return value;
    }

    return value.fullName || value.full_name || formatPersonName(value);
};

const readCreatedBy = (report = {}) => {
    const company = report.company || {};

    return readPerson(
        report.createdBy
        || report.created_by
        || company.createdBy
        || company.created_by
    );
};

const readCreatedAt = (report = {}) => {
    const company = report.company || {};

    return report.createdAt
        || report.created_at
        || company.createdAt
        || company.created_at
        || null;
};

const readProviderName = (report = {}) => {
    const source = resolveKybReportSource(report);
    const service = KYBAvailableServices.find((item) => item.id === source);

    return service?.title || getKybReportDisplayTitle(report);
};

const ExternalReportSummary = ({ t, report }) => {
    const createdAt = readCreatedAt(report);
    const cells = [
        {
            label: "Created By",
            value: readCreatedBy(report),
        },
        {
            label: "Created At",
            value: createdAt
                ? dateUtils.convertDateToDate(createdAt, INTERNATIONAL_DATE_TIME_FORMAT)
                : "",
        },
        {
            label: "Provider",
            value: readProviderName(report),
        },
    ];

    return (
        <View style={styles.reportSummary}>
            <View style={styles.reportSummaryHeader}>
                <Text style={styles.reportSummaryHeaderText}>{t("Report Summary")}</Text>
            </View>
            <View style={{ ...styles.reportSummaryRow, borderBottomLeftRadius: 6, borderBottomRightRadius: 6, overflow: "hidden" }}>
                {cells.map((cell, index) => {
                    const isLast = index === cells.length - 1;

                    return (
                        <View
                            key={cell.label}
                            style={{
                                ...styles.reportSummaryCell,
                                ...(isLast ? styles.reportSummaryCellLast : {}),
                                ...(index === 0 ? { borderBottomLeftRadius: 6, overflow: "hidden" } : {}),
                            }}
                        >
                            <Text style={styles.reportSummaryLabel}>
                                {t(cell.label).toUpperCase()}
                            </Text>
                            <Text style={styles.reportSummaryValue}>
                                {formatDisplayValue(cell.value)}
                            </Text>
                        </View>
                    );
                })}
            </View>
        </View>
    );
};

export default withNamespaces()(ExternalReportSummary);
